module.exports = __webpack_public_path__ + "static/media/green_tick.6352d409.svg";